import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

class NullCloud4 extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={71} width={141}>
        <g fill="none" fillRule="evenodd" fillOpacity="0.2">
          <g transform="translate(-1140 -112)" fill="#EAF7FC">
            <g transform="translate(-18 44)">
              <g transform="translate(0 68)">
                <path d="M1287.59709,47.1086126 L1282.04224,47.1086126 C1282.55159,45.0865314 1282.82824,42.9603367 1282.82824,40.7641907 C1282.82824,27.4514787 1272.83976,16.6594544 1260.51935,16.6594544 C1258.68129,16.6594544 1256.89775,16.904284 1255.18826,17.3581542 C1250.01908,7.07937728 1239.94029,0.102139959 1228.35217,0.102139959 C1215.43534,0.102139959 1204.4005,8.77691684 1199.9441,21.0249047 C1199.30781,20.979355 1198.66584,20.950073 1198.01572,20.950073 C1185.01265,20.950073 1174.47007,30.2902008 1174.47007,41.8118337 C1174.47007,43.4800913 1174.6979,45.100359 1175.11531,46.6555558 C1173.50833,46.6767039 1171.95424,46.8353144 1170.46769,47.1086126 C1168.43435,47.1102394 1166.53528,47.7373611 1164.90633,48.8061521 C1159.73146,51.1332535 1158.3458,55.1164118 1158.3458,59.6429128 C1158.3458,66.8226836 1165.01455,70.4479513 1186.14282,70.4479513 L1287.59709,70.4479513 C1293.53761,70.4479513 1298.39759,65.1967221 1298.39759,58.7782819 C1298.39759,52.3598418 1293.53761,47.1086126 1287.59709,47.1086126" />
              </g>
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

NullCloud4.displayName = "NullCloud4";
NullCloud4.vstuiName = "Icon";

export default NullCloud4;
